import fieldValidation from '../../utils/fieldValidation';

const validationMethods = {
  email: fieldValidation.requiredEmail,
  password: fieldValidation.requiredString,
};

export default validationMethods;
